import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Helper function to check login status.
 * Exported to replace the previous static method and can be used across the app.
 */
export const isLoggedIn = () => !!localStorage.getItem('currentUser');

const authGuardFn: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (isLoggedIn()) {
    return true;
  }

  // If not logged in, redirect to the login page with the return url
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};

// Export as AuthGuard with attached isLoggedIn property for backward compatibility
export const AuthGuard = Object.assign(authGuardFn, { isLoggedIn });
